import { createSelector } from 'reselect';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getUserSettingsAsyncData } from './getUserSettingsAsyncData';
export const getUserSettings = createSelector([getUserSettingsAsyncData], getData);